import { jsxs, jsx } from 'react/jsx-runtime';
import Skeleton from '@fabric-app/ui/components/Skeleton';
import { Container, ThumbnailContainer, ContentContainer } from './ResourceSearchResultItem.js';
import { useState } from 'react';
import { randomIntFromInterval } from '@fabric-app/utils/random';

const ResourceSearchResultItemSkeleton = ({ children, zoomLevel }) => {
  const [itemContentWidth] = useState({
    item1: randomIntFromInterval(100, 230),
    item2: randomIntFromInterval(100, 160),
    item3: randomIntFromInterval(40, 180),
    dim1: randomIntFromInterval(70, 140),
    dim2: randomIntFromInterval(40, 130)
  });
  return /* @__PURE__ */ jsxs(Container, {
    children: [
      /* @__PURE__ */ jsx(ThumbnailContainer, {
        zoomLevel,
        children: /* @__PURE__ */ jsx(Skeleton, {
          borderRadius: 8,
          width: itemContentWidth.dim1,
          height: itemContentWidth.dim2,
          scale: zoomLevel
        })
      }),
      /* @__PURE__ */ jsxs(ContentContainer, {
        children: [
          /* @__PURE__ */ jsx(Skeleton, {
            borderRadius: 4,
            width: itemContentWidth.item1,
            height: 14
          }),
          /* @__PURE__ */ jsx(Skeleton, {
            borderRadius: 4,
            width: itemContentWidth.item2,
            height: 14
          }),
          /* @__PURE__ */ jsx(Skeleton, {
            borderRadius: 4,
            width: itemContentWidth.item3,
            height: 14
          })
        ]
      }),
      children
    ]
  });
};

export { ResourceSearchResultItemSkeleton };
//# sourceMappingURL=ResourceSearchResultItemSkeleton.js.map
